import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Role } from './role';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  public SelectedRole :Role;

  constructor(private httpClient: HttpClient) { }
  
  getBaseUrl() {
    return environment.baseUrl;
  }
  
  IUDRole(FormValue: any) {

    this.SelectedRole.Id = FormValue.value.frmId;
    this.SelectedRole.Name = FormValue.value.frmRoleName;
    this.SelectedRole.code = FormValue.value.frmCode;
    this.SelectedRole.Remarks = FormValue.value.frmRemarks;
    this.SelectedRole.IsActive = FormValue.value.frmActive;
    this.SelectedRole.Flag = FormValue.value.frmFlag;

    this.SelectedRole.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.SelectedRole.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.SelectedRole.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.SelectedRole.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.SelectedRole.CreatedDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.SelectedRole.ModifiedDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = this.SelectedRole;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Role/IUD', body, { headers: headers });
  }

  
  FetchRoleList() {

    this.SelectedRole = new Role();
    this.SelectedRole.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.SelectedRole.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.SelectedRole.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.SelectedRole.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.SelectedRole;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Role/FetchList', body, { headers: headers });
  }

  FetchRoleById(roleId: number) {

    this.SelectedRole = new Role();
    this.SelectedRole.Id = roleId;
    this.SelectedRole.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.SelectedRole.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.SelectedRole.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.SelectedRole.SaasId = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.SelectedRole;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Role/Fetch', body, { headers: headers });
  }

}
